var _defs, _path, _path2, _path3, _circle, _path4, _g, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebsitesTestimonialsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "websites-testimonials-icon_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70.87 70.87"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".websites-testimonials-icon_svg__cls-1,.websites-testimonials-icon_svg__cls-3{fill:#010101;stroke-width:0}.websites-testimonials-icon_svg__cls-3{fill:#e84b0f}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.02 24.63c1.16 11.7-8.59 21.45-20.29 20.29-8.66-.86-15.66-7.86-16.52-16.52C27.05 16.7 36.8 6.95 48.5 8.11c8.66.86 15.66 7.86 16.52 16.52z",
    fill: "#f9d8cd",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.96 33.17H56.4c2.98 0 5.4 2.43 5.4 5.4v13.66c0 2.98-2.43 5.4-5.4 5.4h-2.52v3.4c0 .64-.67 1-1.21.7l-6.98-4.1H34.97a5.41 5.41 0 01-5.4-5.4V38.57c0-2.98 2.43-5.4 5.4-5.4h0z",
    fill: "#e84b0f",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.93 20.57H12.82c-3.37 0-6.07 2.7-6.07 6.07V42c0 3.37 2.7 6.07 6.07 6.07h2.85v3.8c0 .7.76 1.15 1.37.79l7.83-4.58h12.05c3.37 0 6.07-2.7 6.07-6.07V26.65c0-3.34-2.7-6.07-6.07-6.07z",
    fill: "#fff",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "websites-testimonials-icon_svg__cls-3",
    cx: 21.66,
    cy: 30.13,
    r: 1.97
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "websites-testimonials-icon_svg__cls-1",
    d: "M21.66 29.16c.54 0 .97.44.97.97s-.44.97-.97.97-.97-.44-.97-.97.44-.97.97-.97m0-2a2.97 2.97 0 100 5.94 2.97 2.97 0 000-5.94z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "websites-testimonials-icon_svg__cls-3",
    cx: 28.13,
    cy: 30.13,
    r: 1.97
  }), /*#__PURE__*/React.createElement("path", {
    className: "websites-testimonials-icon_svg__cls-1",
    d: "M28.13 29.16c.54 0 .97.44.97.97s-.44.97-.97.97-.97-.44-.97-.97.44-.97.97-.97m0-2a2.97 2.97 0 100 5.94 2.97 2.97 0 000-5.94z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.86 36.05c-4.4 4.4-11.54 4.4-15.94 0",
    fill: "none",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })));
}
export default SvgWebsitesTestimonialsIcon;